module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "zk-menu",
    class: {
      'zk-menu--horizontal': _vm.mode === 'horizontal',
        'zk-menu--dark': _vm.theme === 'dark'
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-a6103bc2"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/menu/src/menu.vue
// module id = 276
// module chunks = 0